import { Settings, BarChart3 } from 'lucide-react'

interface HeaderProps {
  onSettingsClick: () => void
  onStatsClick: () => void
}

/**
 * Top header with logo, UK stats, and settings icons
 */
export function Header({ onSettingsClick, onStatsClick }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-green-600 to-emerald-500 z-50 safe-area-pt shadow-md">
      <div className="flex items-center justify-between h-14 px-4 max-w-2xl mx-auto">
        {/* Logo */}
        <div className="flex items-center">
          <span className="text-2xl text-white tracking-tight">
            <span className="font-bold">Fuel</span>
            <span className="font-light">-Prices.co.uk</span>
          </span>
        </div>

        <div className="flex items-center gap-1">
          {/* UK Stats button */}
          <button
            onClick={onStatsClick}
            className="flex items-center gap-1.5 h-9 min-h-[44px] px-3 rounded-lg text-white/90 hover:text-white bg-white/15 hover:bg-white/25 transition-colors text-sm font-medium"
            aria-label="UK stats"
          >
            <BarChart3 size={16} />
            UK Stats
          </button>

          {/* Settings button */}
          <button
            onClick={onSettingsClick}
            className="flex items-center justify-center w-10 h-10 min-h-[44px] rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
            aria-label="Open settings"
          >
            <Settings size={22} />
          </button>
        </div>
      </div>
    </header>
  )
}
